import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { LanguageProvider, useLanguage } from "./contexts/LanguageContext";
import { ToastProvider, useToast } from "./contexts/ToastContext";
import QueryProvider from "./providers/QueryProvider";
import ToastContainer from "./components/ToastContainer";
import Navbar from "./components/Navbar";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import AuthCallback from "./pages/AuthCallback";
import CourseCatalog from "./pages/CourseCatalog";
import ProgramsPage from "./pages/ProgramsPage";
import ProgramLandingPage from "./pages/ProgramLandingPage";
import CourseDetail from "./pages/CourseDetail";
import Dashboard from "./pages/Dashboard";
import LessonPage from "./pages/LessonPage";
import ProgressDetail from "./pages/ProgressDetail";
import CheckoutPage from "./pages/CheckoutPage";
import ProfilePage from "./pages/ProfilePage";
// NOT: pages/AdminDashboard.jsx ("Genel Bakis") 25 Agustos 2026'da kenar
// cubugundan ve '/admin' kok route'undan cikarildi ama SILINMEDI — artik
// '/admin/genel-bakis' adresinden erisiliyor (menude girdisi YOK, bilincli).
// .js/.jsx ikizi var; canli olan .jsx, uzanti acikca yazilmali.
import AdminDashboard from "./pages/AdminDashboard.jsx";
import AdminPersonelYonetimi from "./pages/AdminPersonelYonetimi.jsx";
import AdminAnnouncements from "./pages/AdminAnnouncements";
import AdminCampaigns from "./pages/AdminCampaigns";
import AdminLogs from "./pages/AdminLogs";
import AdminReviews from "./pages/AdminReviews";
import AdminMessages from "./pages/AdminMessages";
import AdminReports from "./pages/AdminReports";
import AdminContracts from "./pages/AdminContracts";
import AdminAccounting from "./pages/AdminAccounting.jsx";
import AdminInvoices from "./pages/AdminInvoices.jsx";
import AdminMuhasebeListesi from "./pages/AdminMuhasebeListesi.jsx";
import AdminParasutMapping from "./pages/AdminParasutMapping.jsx";
import AdminStudentOps from "./pages/AdminStudentOps";
import AdminStudentDetailPage from "./pages/AdminStudentDetailPage";
import AdminCourseManagerV2 from "./pages/AdminCourseManager.jsx";
import NewUserPage from "./pages/admin/NewUserPage";
import AdminMokaQueue from "./pages/admin/AdminMokaQueue.jsx";
import AdminBankMatchingPool from "./pages/admin/AdminBankMatchingPool.jsx";
import PaymentResult from "./pages/PaymentResult.jsx";
import AdminCertificates from "./pages/AdminCertificates";
import AdminCertPrint from "./pages/AdminCertPrint";
import AdminDijitalRozet from "./pages/AdminDijitalRozet.jsx";
import AdminExamGroups from "./pages/AdminExamGroups";
import AdminDefinitions from "./pages/AdminDefinitions";
import AdminLeads from "./pages/AdminLeads";
import AdminDanismanCockpit from "./pages/AdminDanismanCockpit";
import AdminDanismanYonetimi from "./pages/AdminDanismanYonetimi";
import AdminDanismanAnaSayfa from "./pages/AdminDanismanAnaSayfa";
import AdminDanismanIstatistik from "./pages/AdminDanismanIstatistik";
import AdminMesaiMolaTakip from "./pages/AdminMesaiMolaTakip";
import DanismanOgrenciDetay from "./pages/DanismanOgrenciDetay";
import AdminSatisOnay from "./pages/AdminSatisOnay";
import AdminCiroDashboard from "./pages/AdminCiroDashboard";
import AdminSatisRaporlama from "./pages/AdminSatisRaporlama";
import AdminPrimKurallari from "./pages/AdminPrimKurallari";
import AdminIzinTalepleri from "./pages/AdminIzinTalepleri";
import AdminVimeo from "./pages/AdminVimeo";
import InstructorDashboard from "./pages/InstructorDashboard";
import InstructorCourseEdit from "./pages/InstructorCourseEdit";
import InstructorLessons from "./pages/InstructorLessons";
import FavoritesPage from "./pages/FavoritesPage";
import NotificationsPage from "./pages/NotificationsPage";
import CertificatesPage from "./pages/CertificatesPage";
import DocumentsPage from "./pages/DocumentsPage";
import AdminDocuments from "./pages/AdminDocuments";
import AdminKvkkRequests from "./pages/AdminKvkkRequests";
import AdminNotificationJobs from "./pages/AdminNotificationJobs";
import AdminAppVersion from "./pages/AdminAppVersion";
import AdminLegal from "./pages/AdminLegal";
import AdminLegalContent from "./pages/AdminLegalContent";
import AdminGeoContent from "./pages/AdminGeoContent";
import AdminGeoContentDetail from "./pages/AdminGeoContentDetail";
import AdminActiveSessions from "./pages/AdminActiveSessions";
import AdminAnomalies from "./pages/AdminAnomalies";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import AutoLoginPage from "./pages/AutoLoginPage";
import AdminNewIdentityPage from "./pages/AdminNewIdentityPage";
import AdminStudentSalePage from "./pages/AdminStudentSalePage";
// RegisterPage: web self-register kapatildi (bkz. backend SELF_REGISTER_AKTIF).
// Dosya bilerek silinmedi (bayrak geri acilirsa diye), sadece route'tan cikarildi.
import CabinCrewPage from "./pages/CabinCrewPage";
import CabinLayout from "./layouts/CabinLayout";
import CabinDashboard from "./pages/CabinDashboard";
import CabinRoadmap from "./pages/CabinRoadmap";
import CabinProgress from "./pages/CabinProgress";
import CabinModulesList from "./pages/CabinModulesList";
import CabinModuleDetail from "./pages/CabinModuleDetail";
import CabinLessonPlayer from "./pages/CabinLessonPlayer";
import CabinLeaderboard from "./pages/CabinLeaderboard";
import CabinAchievements from "./pages/CabinAchievements";
import CabinSpinWheel from "./pages/CabinSpinWheel";
import AdminCabinCrewGroups from "./pages/AdminCabinCrewGroups";
import AdminVoicePracticeScenarios from "./pages/AdminVoicePracticeScenarios";
import AdminAviationEnglishScenarios from "./pages/AdminAviationEnglishScenarios";
import AdminAnnounceTemplates from "./pages/AdminAnnounceTemplates";
import AdminPaxCommSituations from "./pages/AdminPaxCommSituations";
import AdminCabinAcademyHub from "./pages/AdminCabinAcademyHub";
import AdminCabinCurriculum from "./pages/AdminCabinCurriculum";
import AdminLessonContent from "./pages/AdminLessonContent";
import BugReportWidget from "./components/BugReportWidget";
import { WhatsAppFloatingButton } from "./components/WhatsAppContactButton";
import AdminBugReports from "./pages/AdminBugReports";
import MyCabinCrewGroup from "./pages/MyCabinCrewGroup";
import ExamPage from "./pages/ExamPage";
import CertificateVerify from "./pages/CertificateVerify";
import LegalPage from "./pages/LegalPage";
import AccountDeletionPage from "./pages/AccountDeletionPage.jsx";
import ContractGate from "./components/ContractGate";
import CabinEnrollmentGuard from "./components/cabin/CabinEnrollmentGuard";
import ScrollToTop from "./components/ScrollToTop";
import ImpersonationBanner from "./components/cabin/ImpersonationBanner";
import CabinInterviewHub from "./pages/CabinInterviewHub";
import CabinInterviewSimulation from "./pages/CabinInterviewSimulation";
import CabinInterviewHistory from "./pages/CabinInterviewHistory";
import CabinInterviewSessionDetail from "./pages/CabinInterviewSessionDetail";
import CabinReadinessReport from "./pages/CabinReadinessReport";
import CabinReadinessCompare from "./pages/CabinReadinessCompare";
import InstructorInterviewReviews from "./pages/InstructorInterviewReviews";
import InstructorInterviewScoring from "./pages/InstructorInterviewScoring";
import InstructorCVReviews from "./pages/InstructorCVReviews";
import InterviewModuleShell from "./layouts/InterviewModuleShell";
import MyCoursesPage from "./pages/MyCoursesPage";
import CabinCVWizard from "./pages/CabinCVWizard";
import CabinVideoLessons from "./pages/CabinVideoLessons";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-app)]">
      <div className="w-10 h-10 border-4 border-[var(--brand-primary)] border-t-transparent rounded-full animate-spin" />
    </div>
  );

  if (!user) {
    // Hedefi koru — LoginPage.js::getReturnTo() zaten AuthContext.js'in 401
    // interceptor'ında kullandığı AYNI ?returnTo= sözleşmesini okuyor (güvenli
    // dahili yol doğrulaması orada yapılıyor). Eskiden burada kayboluyordu —
    // ör. ticari e-postadaki /hesap/bildirim-tercihleri linkine giriş yapmamış
    // haldeyken tıklayan kullanıcı /login'den sonra /dashboard'a düşüyordu.
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />;
  }
  return <ContractGate>{children}</ContractGate>;
}

function RoleRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const { lang } = useLanguage();
  const toast = useToast();
  const unauthorized = !loading && user && !roles.includes(user.role);

  // Sessiz redirect kullanıcıyı şaşırtıyordu — yetkisiz erişimde yönlendirme
  // öncesi toast ile bilgilendir. Render sırasında değil, effect içinde
  // tetiklenir (StrictMode çift-render'da tekrar toast basmasın diye
  // bağımlılık listesi user.role + roles ile sınırlı tutuldu).
  useEffect(() => {
    if (unauthorized) {
      toast.error(lang === 'tr'
        ? 'Bu sayfaya erişim yetkiniz yok'
        : 'You do not have permission to access this page');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unauthorized]);

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-app)]">
      <div className="w-10 h-10 border-4 border-[var(--brand-primary)] border-t-transparent rounded-full animate-spin" />
    </div>
  );

  if (!user) return <Navigate to="/login" replace />;
  if (unauthorized) return <Navigate to="/dashboard" replace />;
  return children;
}

// Eski /danisman/datalar adresi kaldırıldı — Datalar bloğu artık Danışman
// Paneli'nin (/admin/cockpit) altında yaşıyor (bkz. proje-yoneticisi görev
// talimatı, 2026-08-13). Yer imi/derin bağlantıların (ör. LeadDetayModal'daki
// "Data Geçmişi" linki eski sürümleri, ?tab=data-gecmis&lead_id=...) kırılmaması
// için query string KORUNARAK redirect edilir.
function DanismanDatalarRedirect() {
  const location = useLocation();
  return <Navigate to={`/admin/cockpit${location.search}`} replace />;
}

// Eski /danisman/leads (Atanan Leadler) adresi kaldırıldı — Dönüştür / Satışa
// Hazır İşaretle / Kimlik Oluştur / Profil eylemleri LeadDetayModal'ın
// "İşlemler" bölümüne, Satış Taleplerim paneli Danışman Paneli'ne (bkz.
// AdminDanismanCockpit.jsx) taşındı (bkz. proje-yoneticisi görev talimatı,
// 2026-08-13). Yer imi/eski linklerin kırılmaması için query string
// KORUNARAK /admin/cockpit'e redirect edilir.
function AssignedLeadsRedirect() {
  const location = useLocation();
  return <Navigate to={`/admin/cockpit${location.search}`} replace />;
}

function AppRouter() {
  const location = useLocation();

  // StrictMode cift-mount korumasi (AutoLoginPage.jsx:exchangedRef ile ayni
  // desen): dev-only seed effect StrictMode'da mount->cleanup->remount
  // sirasinda IKI KEZ tetikleniyordu -> duplicate seed cagrisi. seededRef
  // ile ikinci mount'ta seed atlanir.
  const seededRef = useRef(false);

  useEffect(() => {
    // Seed endpoints are only needed in development; skip in production to
    // avoid unnecessary requests and unintentional data resets.
    if (process.env.NODE_ENV !== 'production') {
      if (seededRef.current) return;
      seededRef.current = true;
      axios.post(`${API}/seed`).catch(() => {});
      axios.post(`${API}/seed-admin`).catch(() => {});
    }
  }, []);

  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  // Danışman paneli (/danisman, /danisman/leads, /danisman/istatistik vb.)
  // AdminLayout kullanır ama '/admin' önekiyle BAŞLAMAZ — global Navbar (üst
  // bar: logo + dil + zil + avatar) bu yüzden bu route'larda da GİZLENMELİ,
  // yoksa AdminLayout'un panel-içi kullanıcı menüsü/bildirim ziliyle ÇAKIŞIR
  // (bkz. proje-yoneticisi görev talimatı, 2026-08-13 — kullanıcı şikayeti).
  const isDanismanPanelRoute = location.pathname.startsWith('/danisman');
  const isAdminRoute = location.pathname.startsWith('/admin') || isDanismanPanelRoute;

  // ── Interview/CV full-screen route'lar: navbar GIZLI ────────────────────
  // Sadece 3 tam ekran sayfa: sim, session-detail, instructor scoring
  const isInterviewFullScreen =
    location.pathname === '/programs/kabin-memurlugu/interview/sim' ||
    location.pathname.startsWith('/programs/kabin-memurlugu/interview/session/') ||
    /^\/instructor\/interview-reviews\/[^/]+\/score$/.test(location.pathname);

  // ── Cabin route'lar: CabinLayout kendi sidebar'ini tasir, global navbar GIZLI ──
  // ISTISNA: interview/cv dashboard route'lari (isInterviewFullScreen olmayan)
  // artik global Navbar'i gosterir — isInterviewFullScreen kontrolu yeterli.
  const isInterviewDashboard =
    location.pathname === '/programs/kabin-memurlugu/interview' ||
    location.pathname === '/programs/kabin-memurlugu/interview/history' ||
    location.pathname === '/programs/kabin-memurlugu/interview/readiness-report' ||
    location.pathname === '/programs/kabin-memurlugu/cv' ||
    location.pathname === '/instructor/interview-reviews' ||
    location.pathname === '/instructor/cv-reviews';

  // Diger cabin route'lar (dashboard, roadmap, lessons vb) navbar GIZLI kalir
  // /instructor/* route'lari (dashboard, course-edit vb) normal Navbar'i gosterir — sadece
  // full-screen interview/cv route'lari isInterviewFullScreen ile yukarida yakalanir.
  const isCabinRoute =
    location.pathname.startsWith('/programs/kabin-memurlugu') && !isInterviewDashboard && !isInterviewFullScreen;

  // Tum kurslar Udemy full-screen duzenine gectigi icin /lesson/ altindaki her ders
  // global Navbar'i gizler — CabinLessonLayout kendi sticky top-bar'ini kullanir.
  const isCabinLesson = location.pathname.startsWith('/lesson/');

  const isAuthRoute = location.pathname === '/login' || location.pathname === '/register' || location.pathname === '/forgot-password' || location.pathname.startsWith('/reset-password') || location.pathname === '/change-password' || location.pathname === '/auto-login';

  // PUBLIC yasal belge sayfası (/legal/:docType) — standalone, auth/app-shell
  // gerektirmez; kendi minimal header'ını taşır, global Navbar gizlenir
  // (Play Store gizlilik politikası URL'si bu route'u kullanır).
  const isLegalRoute = location.pathname.startsWith('/legal/');

  // PUBLIC hesap silme sayfası (/account-deletion) — LegalPage ile aynı
  // standalone desen; Google Play Data Safety'nin giriş gerektirmeyen
  // silme URL'i şartı için (bkz. AccountDeletionPage.jsx).
  const isAccountDeletionRoute = location.pathname === '/account-deletion';

  // PUBLIC Moka ödeme sonuç sayfası (/odeme-sonuc) — AccountDeletionPage ile
  // AYNI standalone desen, auth GEREKMEZ (bkz. PaymentResult.jsx dosya başı notu).
  const isPaymentResultRoute = location.pathname === '/odeme-sonuc';

  return (
    <>
      <ScrollToTop />
      <ImpersonationBanner />
      {!isAdminRoute && !isCabinRoute && !isInterviewFullScreen && !isAuthRoute && !isCabinLesson && !isLegalRoute && !isAccountDeletionRoute && !isPaymentResultRoute && <Navbar />}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        {/* Self-register kapatildi (SELF_REGISTER_AKTIF=false) — eski link/bookmark
            /login'e yonlendirilir, RegisterPage.js bilerek silinmedi. */}
        <Route path="/register" element={<Navigate to="/login" replace />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/change-password" element={<ChangePasswordPage />} />
        <Route path="/auto-login" element={<AutoLoginPage />} />
        <Route path="/verify/:code" element={<CertificateVerify />} />
        {/* PUBLIC yasal belge — auth GEREKMEZ, ProtectedRoute/RoleRoute'a sarılmaz */}
        <Route path="/legal/:docType" element={<LegalPage />} />
        {/* PUBLIC hesap silme sayfası — auth GEREKMEZ, ProtectedRoute/RoleRoute'a sarılmaz */}
        <Route path="/account-deletion" element={<AccountDeletionPage />} />
        {/* PUBLIC Moka ödeme sonuç sayfası — auth GEREKMEZ, ProtectedRoute/RoleRoute'a sarılmaz */}
        <Route path="/odeme-sonuc" element={<PaymentResult />} />
        <Route path="/courses" element={<CourseCatalog />} />
        <Route path="/my-courses" element={<ProtectedRoute><MyCoursesPage /></ProtectedRoute>} />
        <Route path="/programs" element={<ProgramsPage />} />
        <Route path="/programs/:slug" element={<ProgramLandingPage />} />
        <Route path="/courses/:courseId" element={<CourseDetail />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/lesson/:courseId/:lessonId" element={<ProtectedRoute><CabinEnrollmentGuard><LessonPage /></CabinEnrollmentGuard></ProtectedRoute>} />
        <Route path="/progress/:courseId" element={<ProtectedRoute><ProgressDetail /></ProtectedRoute>} />
        <Route path="/checkout/:courseId" element={<ProtectedRoute><CheckoutPage /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
        {/* Ticari e-postadaki 6563 md.6 opt-out linkinin hedefi — bkz.
            backend/routes/admin_bulk.py::_commercial_email_opt_out_footer.
            Gerçek bir "hesap ayarları" alan adı hiyerarşisi henüz yok, bu
            yüzden ProfilePage'in "Bildirimler" sekmesine ?tab= ile yönlendirir
            (bkz. ProfilePage.js — useSearchParams ile ilk sekmeyi okur). */}
        <Route path="/hesap/bildirim-tercihleri" element={<ProtectedRoute><Navigate to="/profile?tab=notifications" replace /></ProtectedRoute>} />
        <Route path="/favorites" element={<ProtectedRoute><FavoritesPage /></ProtectedRoute>} />
        <Route path="/bildirimler" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
        {/* Duyuru deeplink hedefi — backend'de gerçek bir duyuru detay
            sayfası/endpoint'i yok (bkz. AdminAnnouncements.js: 'link' alanı
            hiç yok, backend'de public GET /announcements/{id} da yok). Bu
            yüzden şimdilik bildirimin zaten tam içeriğini gösterdiği bildirim
            merkezine yönlendiriyoruz — landing'e düşme regresyonunu giderir.
            Gerçek bir duyuru detay sayfası eklenirse bu route ona bağlanmalı. */}
        <Route path="/announcements/:id" element={<ProtectedRoute><Navigate to="/bildirimler" replace /></ProtectedRoute>} />
        <Route path="/certificates" element={<ProtectedRoute><CertificatesPage /></ProtectedRoute>} />
        <Route path="/documents" element={<ProtectedRoute><DocumentsPage /></ProtectedRoute>} />
        <Route path="/cabin-crew" element={<ProtectedRoute><CabinCrewPage /></ProtectedRoute>} />
        <Route path="/my-cabin-crew-group" element={<ProtectedRoute><MyCabinCrewGroup /></ProtectedRoute>} />
        <Route path="/exam/:courseId" element={<ProtectedRoute><ExamPage /></ProtectedRoute>} />
        {/* Cabin Crew Program Routes — M5.2 — CabinEnrollmentGuard ile korunanlar */}
        <Route
          path="/programs/kabin-memurlugu/dashboard"
          element={
            <ProtectedRoute>
              <CabinEnrollmentGuard>
                <CabinLayout>
                  <CabinDashboard />
                </CabinLayout>
              </CabinEnrollmentGuard>
            </ProtectedRoute>
          }
        />
        <Route
          path="/programs/kabin-memurlugu/roadmap"
          element={
            <ProtectedRoute>
              <CabinEnrollmentGuard>
                <CabinLayout>
                  <CabinRoadmap />
                </CabinLayout>
              </CabinEnrollmentGuard>
            </ProtectedRoute>
          }
        />
        <Route
          path="/programs/kabin-memurlugu/progress"
          element={
            <ProtectedRoute>
              <CabinEnrollmentGuard>
                <CabinLayout>
                  <CabinProgress />
                </CabinLayout>
              </CabinEnrollmentGuard>
            </ProtectedRoute>
          }
        />
        <Route
          path="/programs/kabin-memurlugu/modules"
          element={
            <ProtectedRoute>
              <CabinEnrollmentGuard>
                <CabinLayout>
                  <CabinModulesList />
                </CabinLayout>
              </CabinEnrollmentGuard>
            </ProtectedRoute>
          }
        />
        <Route
          path="/programs/kabin-memurlugu/modules/:moduleSlug"
          element={
            <ProtectedRoute>
              <CabinEnrollmentGuard>
                <CabinLayout>
                  <CabinModuleDetail />
                </CabinLayout>
              </CabinEnrollmentGuard>
            </ProtectedRoute>
          }
        />
        <Route
          path="/programs/kabin-memurlugu/lessons/:lessonId"
          element={
            <ProtectedRoute>
              <CabinEnrollmentGuard>
                <CabinLessonPlayer />
              </CabinEnrollmentGuard>
            </ProtectedRoute>
          }
        />
        <Route
          path="/programs/kabin-memurlugu/leaderboard"
          element={
            <ProtectedRoute>
              <CabinEnrollmentGuard>
                <CabinLayout>
                  <CabinLeaderboard />
                </CabinLayout>
              </CabinEnrollmentGuard>
            </ProtectedRoute>
          }
        />
        <Route
          path="/programs/kabin-memurlugu/achievements"
          element={
            <ProtectedRoute>
              <CabinEnrollmentGuard>
                <CabinLayout>
                  <CabinAchievements />
                </CabinLayout>
              </CabinEnrollmentGuard>
            </ProtectedRoute>
          }
        />
        {/* M5.5 — Spin Wheel & PA Announcement */}
        <Route
          path="/programs/kabin-memurlugu/spin-wheel"
          element={
            <ProtectedRoute>
              <CabinEnrollmentGuard>
                <CabinLayout>
                  <CabinSpinWheel />
                </CabinLayout>
              </CabinEnrollmentGuard>
            </ProtectedRoute>
          }
        />
        {/* ── Kariyer Online Shell — Interview + CV modulu ── */}
        {/* M5.6 — Mulakat Simulasyonu hub (Ekran 4 / ogrenci) */}
        <Route
          path="/programs/kabin-memurlugu/interview"
          element={
            <ProtectedRoute>
              <CabinEnrollmentGuard>
                <InterviewModuleShell>
                  <CabinInterviewHub />
                </InterviewModuleShell>
              </CabinEnrollmentGuard>
            </ProtectedRoute>
          }
        />
        {/* Simulasyon kayit ekrani — full-screen, shell sidebar gizli */}
        <Route
          path="/programs/kabin-memurlugu/interview/sim"
          element={
            <ProtectedRoute>
              <CabinEnrollmentGuard>
                <InterviewModuleShell isFullScreen>
                  <CabinInterviewSimulation />
                </InterviewModuleShell>
              </CabinEnrollmentGuard>
            </ProtectedRoute>
          }
        />
        {/* Gecmis oturumlar listesi */}
        <Route
          path="/programs/kabin-memurlugu/interview/history"
          element={
            <ProtectedRoute>
              <CabinEnrollmentGuard>
                <InterviewModuleShell>
                  <CabinInterviewHistory />
                </InterviewModuleShell>
              </CabinEnrollmentGuard>
            </ProtectedRoute>
          }
        />
        {/* Ekran 6 ogrenci — Oturum incele (full-screen: isReview) */}
        <Route
          path="/programs/kabin-memurlugu/interview/session/:sessionId"
          element={
            <ProtectedRoute>
              <CabinEnrollmentGuard>
                <InterviewModuleShell isFullScreen>
                  <CabinInterviewSessionDetail />
                </InterviewModuleShell>
              </CabinEnrollmentGuard>
            </ProtectedRoute>
          }
        />
        {/* Ekran 5 — Hazirlik Raporu (ogrenci sidebar'li) */}
        <Route
          path="/programs/kabin-memurlugu/interview/readiness-report"
          element={
            <ProtectedRoute>
              <CabinEnrollmentGuard>
                <InterviewModuleShell>
                  <CabinReadinessReport />
                </InterviewModuleShell>
              </CabinEnrollmentGuard>
            </ProtectedRoute>
          }
        />
        {/* F3 — Gelisim Karsilastirmasi */}
        <Route
          path="/programs/kabin-memurlugu/interview/readiness-report/compare"
          element={
            <ProtectedRoute>
              <CabinEnrollmentGuard>
                <InterviewModuleShell>
                  <CabinReadinessCompare />
                </InterviewModuleShell>
              </CabinEnrollmentGuard>
            </ProtectedRoute>
          }
        />
        {/* CV Wizard — sidebar'li */}
        <Route
          path="/programs/kabin-memurlugu/cv"
          element={
            <ProtectedRoute>
              <CabinEnrollmentGuard>
                <InterviewModuleShell>
                  <CabinCVWizard />
                </InterviewModuleShell>
              </CabinEnrollmentGuard>
            </ProtectedRoute>
          }
        />
        {/* M5.x — Video Dersler */}
        <Route
          path="/programs/kabin-memurlugu/video-lessons"
          element={
            <ProtectedRoute>
              <CabinEnrollmentGuard>
                <CabinLayout>
                  <CabinVideoLessons />
                </CabinLayout>
              </CabinEnrollmentGuard>
            </ProtectedRoute>
          }
        />
        {/* Redirect /programs/kabin-memurlugu to dashboard (guard burada gereksiz — redirect) */}
        <Route
          path="/programs/kabin-memurlugu"
          element={<Navigate to="/programs/kabin-memurlugu/dashboard" replace />}
        />
        {/* Admin Routes */}
        {/* '/admin' kok route'u artik Danisman Ana Sayfasi'ni gosterir (Navigate
            DEGIL: URL korunuyor, '/admin'e link veren breadcrumb'lar kirilmiyor).
            Rol kapisi bilerek ['admin','superadmin'] kaldi — '/danisman'
            route'undan farkli olarak danisman rolu buraya giremez, mevcut
            davranis degismedi. AdminDashboard sayfasi silinmedi, yalnizca
            kenar cubugundan ve bu route'tan kaldirildi. */}
        <Route path="/admin" element={<RoleRoute roles={['admin', 'superadmin']}><AdminDanismanAnaSayfa /></RoleRoute>} />
        {/* Eski "Genel Bakis" ekrani. Kenar cubugunda girdisi YOK (bilincli:
            "cok fazla menu oldu" geri bildirimi) ama sayfa erisilebilir
            kalmali — '/admin' artik Danisman Ana Sayfasi'ni tuketiyor, bu
            yuzden ayri bir adrese tasindi. Rol kapisi degismedi. */}
        <Route path="/admin/genel-bakis" element={<RoleRoute roles={['admin', 'superadmin']}><AdminDashboard /></RoleRoute>} />
        <Route path="/admin/personel-yonetimi" element={<RoleRoute roles={['admin', 'superadmin']}><AdminPersonelYonetimi /></RoleRoute>} />
        <Route path="/admin/courses" element={<RoleRoute roles={['admin', 'superadmin']}><AdminCourseManagerV2 /></RoleRoute>} />
        <Route path="/admin/announcements" element={<RoleRoute roles={['admin', 'superadmin']}><AdminAnnouncements /></RoleRoute>} />
        <Route path="/admin/campaigns" element={<RoleRoute roles={['admin', 'superadmin']}><AdminCampaigns /></RoleRoute>} />
        <Route path="/admin/logs" element={<RoleRoute roles={['admin', 'superadmin']}><AdminLogs /></RoleRoute>} />
        <Route path="/admin/reviews" element={<RoleRoute roles={['admin', 'superadmin']}><AdminReviews /></RoleRoute>} />
        <Route path="/admin/messages" element={<RoleRoute roles={['admin', 'superadmin']}><AdminMessages /></RoleRoute>} />
        <Route path="/admin/reports" element={<RoleRoute roles={['admin', 'superadmin']}><AdminReports /></RoleRoute>} />
        <Route path="/admin/contracts" element={<RoleRoute roles={['admin', 'superadmin']}><AdminContracts /></RoleRoute>} />
        <Route path="/admin/accounting" element={<RoleRoute roles={['admin', 'superadmin']}><AdminAccounting /></RoleRoute>} />
        <Route path="/admin/moka-queue" element={<RoleRoute roles={['admin', 'superadmin']}><AdminMokaQueue /></RoleRoute>} />
        <Route path="/admin/bank-matching-pool" element={<RoleRoute roles={['admin', 'superadmin']}><AdminBankMatchingPool /></RoleRoute>} />
        <Route path="/admin/invoices" element={<RoleRoute roles={['admin', 'superadmin']}><AdminInvoices /></RoleRoute>} />
        <Route path="/admin/muhasebe-listesi" element={<RoleRoute roles={['admin', 'superadmin']}><AdminMuhasebeListesi /></RoleRoute>} />
        <Route path="/admin/parasut-mapping" element={<RoleRoute roles={['admin', 'superadmin']}><AdminParasutMapping /></RoleRoute>} />
        <Route path="/admin/students" element={<RoleRoute roles={['admin', 'superadmin']}><AdminStudentOps /></RoleRoute>} />
        <Route path="/admin/students/new-identity" element={<RoleRoute roles={['admin', 'superadmin']}><AdminNewIdentityPage /></RoleRoute>} />
        <Route path="/admin/students/:userId" element={<RoleRoute roles={['admin', 'superadmin']}><AdminStudentDetailPage /></RoleRoute>} />
        <Route path="/admin/students/:userId/sale" element={<RoleRoute roles={['admin', 'superadmin']}><AdminStudentSalePage /></RoleRoute>} />
        <Route path="/admin/exam-groups" element={<RoleRoute roles={['admin', 'superadmin']}><AdminExamGroups /></RoleRoute>} />
        <Route path="/admin/users/new" element={<RoleRoute roles={['admin', 'superadmin']}><NewUserPage /></RoleRoute>} />
        <Route path="/admin/student-ops" element={<Navigate to="/admin/students" replace />} />
        <Route path="/admin/student-enroll" element={<Navigate to="/admin/users/new" replace />} />
        <Route path="/admin/course-manager" element={<Navigate to="/admin/courses" replace />} />
        <Route path="/admin/cabin-crew" element={<Navigate to="/admin/courses?tab=cabin_crew" replace />} />
        <Route path="/admin/certificates" element={<RoleRoute roles={['admin', 'superadmin']}><AdminCertificates /></RoleRoute>} />
        <Route path="/admin/cert-print" element={<RoleRoute roles={['admin', 'superadmin']}><AdminCertPrint /></RoleRoute>} />
        <Route path="/admin/dijital-rozet" element={<RoleRoute roles={['admin', 'superadmin']}><AdminDijitalRozet /></RoleRoute>} />
        <Route path="/admin/definitions" element={<RoleRoute roles={['admin', 'superadmin']}><AdminDefinitions /></RoleRoute>} />
        <Route path="/admin/leads" element={<RoleRoute roles={['admin', 'superadmin']}><AdminLeads /></RoleRoute>} />
        <Route path="/admin/danismanlar" element={<RoleRoute roles={['admin', 'superadmin']}><AdminDanismanYonetimi /></RoleRoute>} />
        <Route path="/admin/satis-onay" element={<RoleRoute roles={['admin', 'superadmin']}><AdminSatisOnay /></RoleRoute>} />
        <Route path="/admin/ciro-dashboard" element={<RoleRoute roles={['danisman', 'admin', 'superadmin']}><AdminCiroDashboard /></RoleRoute>} />
        <Route path="/admin/satis-raporlama" element={<RoleRoute roles={['admin', 'superadmin']}><AdminSatisRaporlama /></RoleRoute>} />
        <Route path="/admin/prim-kurallari" element={<RoleRoute roles={['admin', 'superadmin']}><AdminPrimKurallari /></RoleRoute>} />
        <Route path="/admin/izin-talepleri" element={<RoleRoute roles={['admin', 'superadmin']}><AdminIzinTalepleri /></RoleRoute>} />
        <Route path="/danisman/leads" element={<RoleRoute roles={['danisman', 'admin', 'superadmin']}><AssignedLeadsRedirect /></RoleRoute>} />
        <Route path="/admin/cockpit" element={<RoleRoute roles={['danisman', 'admin', 'superadmin']}><AdminDanismanCockpit /></RoleRoute>} />
        {/* Eski Datalar sayfası kaldırıldı — /admin/cockpit'e (query string korunarak) redirect */}
        <Route path="/danisman/datalar" element={<RoleRoute roles={['danisman', 'admin', 'superadmin']}><DanismanDatalarRedirect /></RoleRoute>} />
        <Route path="/danisman" element={<RoleRoute roles={['danisman', 'admin', 'superadmin']}><AdminDanismanAnaSayfa /></RoleRoute>} />
        <Route path="/danisman/istatistik" element={<RoleRoute roles={['danisman', 'admin', 'superadmin']}><AdminDanismanIstatistik /></RoleRoute>} />
        {/* Mesai & Mola Takibi (25 Agustos 2026) — rol seti istatistik ile
            AYNI: ekran para/lead degil saat damgasi gosteriyor, danisman da
            tum ekibi gorebiliyor (bkz. sayfa ve backend docstring'leri). */}
        <Route path="/danisman/mesai-mola" element={<RoleRoute roles={['danisman', 'admin', 'superadmin']}><AdminMesaiMolaTakip /></RoleRoute>} />
        {/* Danışmana özel sade öğrenci detay (bkz. proje-yoneticisi görev talimatı,
            2026-08-14 — İş B) — /admin/students/:userId (tam yönetici görünümü)
            DEĞİL, DanismanOgrenciDetay.jsx dosya başı yorumuna bkz. */}
        <Route path="/danisman/ogrenci/:userId" element={<RoleRoute roles={['danisman', 'admin', 'superadmin']}><DanismanOgrenciDetay /></RoleRoute>} />
        <Route path="/admin/cabin-crew-groups" element={<RoleRoute roles={['admin', 'superadmin']}><AdminCabinCrewGroups /></RoleRoute>} />
        <Route path="/admin/documents" element={<RoleRoute roles={['admin', 'superadmin']}><AdminDocuments /></RoleRoute>} />
        <Route path="/admin/kvkk-requests" element={<RoleRoute roles={['admin', 'superadmin']}><AdminKvkkRequests /></RoleRoute>} />
        <Route path="/admin/legal-content" element={<RoleRoute roles={['admin', 'superadmin']}><AdminLegalContent /></RoleRoute>} />
        <Route path="/admin/geo-content" element={<RoleRoute roles={['admin', 'superadmin']}><AdminGeoContent /></RoleRoute>} />
        <Route path="/admin/geo-content/:articleId" element={<RoleRoute roles={['admin', 'superadmin']}><AdminGeoContentDetail /></RoleRoute>} />
        <Route path="/admin/vimeo" element={<RoleRoute roles={['admin', 'superadmin']}><AdminVimeo /></RoleRoute>} />
        <Route path="/admin/enrollments" element={<Navigate to="/admin/students" replace />} />
        <Route path="/admin/notification-jobs" element={<RoleRoute roles={['admin', 'superadmin']}><AdminNotificationJobs /></RoleRoute>} />
        <Route path="/admin/app-version" element={<RoleRoute roles={['admin', 'superadmin']}><AdminAppVersion /></RoleRoute>} />
        <Route path="/admin/legal" element={<RoleRoute roles={['admin', 'superadmin']}><AdminLegal /></RoleRoute>} />
        <Route path="/admin/active-sessions" element={<RoleRoute roles={['admin', 'superadmin']}><AdminActiveSessions /></RoleRoute>} />
        <Route path="/admin/anomalies" element={<RoleRoute roles={['admin', 'superadmin']}><AdminAnomalies /></RoleRoute>} />
        {/* Cabin Module Admin Routes */}
        <Route path="/admin/cabin-academy" element={<RoleRoute roles={['admin', 'superadmin']}><AdminCabinAcademyHub /></RoleRoute>} />
        <Route path="/admin/cabin-curriculum" element={<RoleRoute roles={['admin', 'superadmin']}><AdminCabinCurriculum /></RoleRoute>} />
        <Route path="/admin/cabin-curriculum/lessons/:lessonId" element={<RoleRoute roles={['admin', 'superadmin']}><AdminLessonContent /></RoleRoute>} />
        <Route path="/admin/bug-reports" element={<RoleRoute roles={['admin', 'superadmin']}><AdminBugReports /></RoleRoute>} />
        <Route path="/admin/voice-practice-scenarios" element={<RoleRoute roles={['admin', 'superadmin']}><AdminVoicePracticeScenarios /></RoleRoute>} />
        <Route path="/admin/aviation-english-scenarios" element={<RoleRoute roles={['admin', 'superadmin']}><AdminAviationEnglishScenarios /></RoleRoute>} />
        <Route path="/admin/announce-templates" element={<RoleRoute roles={['admin', 'superadmin']}><AdminAnnounceTemplates /></RoleRoute>} />
        <Route path="/admin/pax-comm-situations" element={<RoleRoute roles={['admin', 'superadmin']}><AdminPaxCommSituations /></RoleRoute>} />
        {/* Instructor Routes */}
        <Route path="/instructor" element={<RoleRoute roles={['instructor', 'admin', 'superadmin']}><InstructorDashboard /></RoleRoute>} />
        <Route path="/instructor/courses/new" element={<RoleRoute roles={['instructor', 'admin', 'superadmin']}><InstructorCourseEdit /></RoleRoute>} />
        <Route path="/instructor/courses/:courseId/edit" element={<RoleRoute roles={['instructor', 'admin', 'superadmin']}><InstructorCourseEdit /></RoleRoute>} />
        <Route path="/instructor/courses/:courseId/lessons" element={<RoleRoute roles={['instructor', 'admin', 'superadmin']}><InstructorLessons /></RoleRoute>} />
        {/* Ekran 1 — Mulakat Degerlendirmeleri (egitmen, sidebar'li) */}
        <Route
          path="/instructor/interview-reviews"
          element={
            <RoleRoute roles={['instructor', 'admin', 'superadmin']}>
              <InterviewModuleShell>
                <InstructorInterviewReviews />
              </InterviewModuleShell>
            </RoleRoute>
          }
        />
        {/* Ekran 3 — F4 puanlama tam ekran (isScore — sidebar gizli) */}
        <Route
          path="/instructor/interview-reviews/:sessionId/score"
          element={
            <RoleRoute roles={['instructor', 'admin', 'superadmin']}>
              <InterviewModuleShell isFullScreen>
                <InstructorInterviewScoring />
              </InterviewModuleShell>
            </RoleRoute>
          }
        />
        {/* Ekran 2 — CV Degerlendirmeleri (egitmen, sidebar'li) */}
        <Route
          path="/instructor/cv-reviews"
          element={
            <RoleRoute roles={['instructor', 'admin', 'superadmin']}>
              <InterviewModuleShell>
                <InstructorCVReviews />
              </InterviewModuleShell>
            </RoleRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <BugReportWidget />
      <WhatsAppFloatingButton />
    </>
  );
}

function App() {
  return (
    <QueryProvider>
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <ToastProvider>
              <AppRouter />
              <ToastContainer />
            </ToastProvider>
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </QueryProvider>
  );
}

export default App;
